import '@/assets/styles/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Capacitor } from '@capacitor/core';
import App from './App.vue';
import router from '@/core/router';
import i18n, { initializeI18n } from '@/core/i18n';
import { ToastService } from '@/shared/utilities/feedback/toast-service';
import { showLaunchError } from './launch-screen';
import requiredStar from '@/shared/directives/v-required-star';

document.documentElement.classList.add(`platform-${Capacitor.getPlatform()}`);
const app = createApp(App);
app.use(createPinia());
app.use(i18n);
app.directive('required-star', requiredStar);
ToastService.setTranslator(i18n.global.t);
try {
  await initializeI18n();
  app.use(router);
  await router.isReady();
  app.mount('#app');
} catch (error) {
  await showLaunchError(i18n.global.t);
  throw error;
}
